export const MapCenter = {
    lat: -21.13292817445635, lng: -47.994757598803965
}

export const MapZoom = 14;